module.exports = __webpack_public_path__ + "assets/img/Vouchers.8e694f91.svg";